import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { timeout } from '@/utils/common'

interface HomeAlerta {
  id: string,
  tipo: {
    key: string,
    display: string,
  },
  procedimento: string,
  pacienteNome: string,
  medicoNome: string,
  tempoDecorrido: number,
}

@Module({ namespaced: true, name: 'HomeAlertasStore' })
export default class HomeAlertasStore extends VuexModule {
  public alertasTableHeader: any[] = [
    { text: 'Tipo', value: 'tipo', sortable: false },
    { text: 'Procedimento', value: 'procedimento', sortable: false },
    { text: 'Paciente', value: 'pacienteNome', sortable: false },
    { text: 'Médico', value: 'medicoNome', sortable: false },
    { text: 'Aguardando ação', value: 'tempoDecorrido', sortable: false },
    { text: '', value: '', sortable: false },
  ]

  private alertasDefault: HomeAlerta[] = []
  public alertas: HomeAlerta[] = [...this.alertasDefault]

  @Mutation
  setAlertas(value: HomeAlerta[]) {
    this.alertas = value
  }

  @Mutation
  clearAlertas() {
    this.alertas = [...this.alertasDefault]
  }

  @Action
  async getAlertasSummaryData() {
    try {
      const request = {
        success: true,
        data: [
          {
            id: '58cb1e70-8df7-4d39-a27d-7ad89c33886c',
            tipo: {
              key: 'Pendencia',
              display: 'Pendência',
            },
            procedimento: 'Desvio de septo e carne esponjosa',
            pacienteNome: 'Marcos Andrade Carmelo e Souza',
            medicoNome: 'Adriano Vaz de Medeiros',
            tempoDecorrido: 18890,
          },
          {
            id: '109ca0c0-bafd-44d8-b4da-9c94f3192e34',
            tipo: {
              key: 'Chatx',
              display: 'Chat-x',
            },
            procedimento: 'Endoscopia digestiva alta com biópsia e/ou citologia',
            pacienteNome: 'Nuno Gonçalves Dias',
            medicoNome: 'Telma Pereira de Melo',
            tempoDecorrido: 289,
          },
          {
            id: '1cf5f829-4e91-495d-b97d-c3f68c25e94f',
            tipo: {
              key: 'Chatx',
              display: 'Chat-x',
            },
            procedimento: 'Polissonografia de noite inteira',
            pacienteNome: 'Patrícia Albquerque Moreira',
            medicoNome: 'Jadiel Mascarenhas Costa',
            tempoDecorrido: 2490,
          },
          {
            id: '569f8003-fe88-4517-a9a3-6c59abfea7c7',
            tipo: {
              key: 'Pendencia',
              display: 'Pendência',
            },
            procedimento: 'Ecocardiograma com Doppler convencional',
            pacienteNome: 'Geraldo Bueno Weiss',
            medicoNome: 'Maria das Graças Silva Coutinho',
            tempoDecorrido: 512,
          },
          {
            id: '779f8003-fe88-4517-a9a3-6c59abfea7c7',
            tipo: {
              key: 'Pendencia',
              display: 'Pendência',
            },
            procedimento: 'Colonoscopia',
            pacienteNome: 'Mariana Vaz Bittencourt',
            medicoNome: 'Tereza Alvarenga Bismark',
            tempoDecorrido: 36,
          },
        ],
      }

      await timeout(3000)
      this.context.commit('setAlertas', request.data as HomeAlerta[] || [])
      return request
    } catch (error) {
      this.context.commit('setAlertas', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
